export const WIDGET_SUMMARY = 'summary';